// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"770":"917f8cc1","2181":"dbba44b9","3001":"3721c70f"}[chunkId] + ".chunk.css";
};